module.exports = __webpack_public_path__ + "static/img/video-6.f33bb85.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/video/video-6.jpg
// module id = pf2r
// module chunks = 12